// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"RQ-z","inlineTitle":"SQ-z","sponsoredAdsWrapper":"TQ-z","marketplaceRecosWrapper":"UQ-z"};